module.exports = __webpack_public_path__ + "static/media/infoJumbo1.9dcb192c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/bodor/images/infoJumbo1.jpg
// module id = 580
// module chunks = 0